export default __webpack_public_path__ + "static/media/serveMob.67f62541.mp4";